/**
 *
 * Add / Update Repository -> GitLab, Github, Bitbucket
 *
 */

import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { Box, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { PageHeaderWithIcon } from 'components/DataDisplay';
import { selectCloudAccounts } from 'containers/Setup/CloudAccounts/selectors';
import { AddRepositoryForm } from 'containers/Setup/Integrations/Components/IntegrationsWizard/DataSources/Components/AddRepository/AddRepositoryForm';
import { getLabel } from 'containers/Setup/Integrations/hooks/utils';

const repositoryProviderMapping: Partial<
  Record<CloudProviders, CloudProviders>
> = {
  [CloudProviders.GitlabIac]: CloudProviders.Gitlab,
  [CloudProviders.GithubIac]: CloudProviders.Github,
  [CloudProviders.BitbucketIac]: CloudProviders.Bitbucket,
};

export const AddRepository = () => {
  const { accountDetails } = useSelector(selectCloudAccounts);
  const navigate = useNavigate();

  const params = useParams<{
    provider: string;
    id: string;
  }>();

  const routeProvider = params.provider as CloudProviders;
  const selectedProvider =
    repositoryProviderMapping[routeProvider] ?? routeProvider;
  const actionType = params.id ? 'Update' : 'Add';

  return (
    <Stack spacing={6} w="full">
      <Box>
        <PageHeaderWithIcon
          label={`${actionType} ${getLabel(selectedProvider)}`}
          iconType={selectedProvider}
          reversed
        />
      </Box>
      <AddRepositoryForm
        onCancel={() => navigate('/setup/accounts')}
        onSuccess={() => navigate('/setup/accounts', { replace: true })}
        selectedProvider={selectedProvider}
        actionType={actionType}
        accountDetails={accountDetails.data}
        styles={{ form: { formWidth: 'full', container: { w: 'full' } } }}
      />
    </Stack>
  );
};
